import intervalToDuration from 'date-fns/intervalToDuration';
import { padStart } from 'lodash';

import type { Maybe } from '@swf/generated/graphql/scoreboards/schemas';

export const formatEventStatusDuration = (
  intervalInSeconds: Maybe<number> | number | undefined,
  prefix = ' - '
) => {
  if (!intervalInSeconds) return '';

  const duration = intervalToDuration({ start: 0, end: intervalInSeconds * 1_000 });
  const minutes = padStart(String(duration.minutes), 2, '0');
  const seconds = padStart(String(duration.seconds), 2, '0');

  return `${prefix}${minutes}:${seconds}`;
};
